export default __webpack_public_path__ + "NoImageFound.e8ee1c68.jpg";